import { Exception } from '../Exception';

export class AddInFeatureNotSupportedException extends Exception {
  constructor(message: string) {
    super(message);
  }
}
